import React from 'react';
import { FolderInput, Mail, UserPlus, Calculator } from 'lucide-react';

const eur = (v) => Number(v || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
const LIB = { nom: 'Nom', prenom: 'Prénom', email: 'E-mail', telephone: 'Téléphone', raison_sociale: 'Raison sociale', siret: 'SIRET',
  adresse: 'Adresse', code_postal: 'Code postal', ville: 'Ville', activite: 'Activité', statut_juridique: 'Statut juridique', code_naf: 'Code NAF', territoire: 'Territoire' };

const Pieces = ({ fichiers, id }) => (fichiers?.length ? (
  <div className="border-t border-slate-100 pt-2" data-testid={`klarys-pieces-${id}`}>
    <p className="flex items-center gap-1.5 font-semibold"><FolderInput className="h-3.5 w-3.5 text-[#0a3d62]" /> Pièces à téléverser dans la GED</p>
    <ul className="mt-1 list-disc pl-5">{fichiers.map((f) => <li key={f.id}>{f.nom}</li>)}</ul>
  </div>
) : null);

export const ApercuMembre = ({ c, id }) => (
  <div className="mt-2 space-y-2 rounded-lg border border-slate-200 bg-white p-2.5 text-xs text-slate-700" data-testid={`klarys-creer-membre-${id}`}>
    <p className="flex items-center gap-1.5 font-semibold"><UserPlus className="h-3.5 w-3.5 text-[#0a3d62]" /> Nouvelle fiche membre</p>
    <div className="grid grid-cols-[110px_1fr] gap-x-2 gap-y-0.5">
      {Object.entries(LIB).filter(([k]) => c.corps?.[k]).map(([k, l]) => (
        <React.Fragment key={k}><span className="text-slate-500">{l}</span><b data-testid={`klarys-creer-membre-${k}-${id}`}>{c.corps[k]}</b></React.Fragment>
      ))}
    </div>
    <p className="flex items-center gap-1.5 text-amber-800"><Mail className="h-3.5 w-3.5" /> L'e-mail d'invitation sera envoyé à {c.corps?.email}</p>
    <Pieces fichiers={c.fichiers} id={id} />
  </div>
);

export const ApercuPieces = ({ c, id }) => (
  <div className="mt-2 rounded-lg border border-slate-200 bg-white p-2.5 text-xs text-slate-700" data-testid={`klarys-classer-pieces-${id}`}>
    <p>GED : <b>{c.membre_nom}{c.numero_membre ? ` (${c.numero_membre})` : ''} / {c.sous_dossier}</b></p>
    <Pieces fichiers={c.fichiers} id={id} />
  </div>
);

export const ApercuSimulation = ({ c, id }) => (
  <div className="mt-2 space-y-2 rounded-lg border border-slate-200 bg-white p-2.5 text-xs text-slate-700" data-testid={`klarys-simulation-${id}`}>
    <p className="flex items-center gap-1.5 font-semibold"><Calculator className="h-3.5 w-3.5 text-[#0a3d62]" /> {c.libelle} — {c.membre_nom}</p>
    <div className="grid grid-cols-3 gap-2">
      <div className="rounded bg-slate-50 p-2"><p className="text-slate-500">CA HT</p><b>{eur(c.ca_ht)}</b></div>
      <div className="rounded bg-slate-50 p-2"><p className="text-slate-500">Contribution HT</p><b data-testid={`klarys-simulation-ht-${id}`}>{eur(c.montant_ht)}</b></div>
      <div className="rounded bg-[#0a3d62] p-2 text-white"><p className="opacity-80">Montant global</p><b data-testid={`klarys-simulation-ttc-${id}`}>{eur(c.montant_ttc)}</b></div>
    </div>
    {c.info?.contrat && <p>Avenant au contrat <b>{c.info.contrat}</b> — prorata {c.info.jours_restants} jours (écart annuel {eur(c.info.ecart_annuel_ttc)})</p>}
    <p>Activités : {(c.activites || []).join(' · ')}</p>
    {c.envoyer && <p className="flex items-center gap-1.5 text-amber-800" data-testid={`klarys-simulation-email-${id}`}><Mail className="h-3.5 w-3.5" /> Envoi du devis à {c.email} — {c.objet}</p>}
  </div>
);
